import { GoogleReCaptchaProvider } from 'lib/react-google-recaptcha-v3';
import { useState } from 'react';
import { Col, Divider, Row } from 'ui';
import { GiveNowProvider } from '../context/give-now-provider';
import { StepForm } from './step-form';
import { Stepper } from './stepper';
import { GiveStepsEnum } from './types';

type P = {
  getPathToGivingDetail: (id: string) => string;
  paymentRedirectUrl: string;
};

const CreateGiveSteps = ({ getPathToGivingDetail, paymentRedirectUrl }: P) => {
  const [step, setStep] = useState(GiveStepsEnum.OPTIONS);

  return (
    <Row justify="center">
      <Col span={12}>
        <Stepper step={step} />
      </Col>
      <Col span={24}>
        <Divider />
        <GiveNowProvider>
          <GoogleReCaptchaProvider>
            <StepForm
              getPathToGivingDetail={getPathToGivingDetail}
              paymentRedirectUrl={paymentRedirectUrl}
              setStep={setStep}
              step={step}
            />
          </GoogleReCaptchaProvider>
        </GiveNowProvider>
      </Col>
    </Row>
  );
};

export default CreateGiveSteps;
